import dispatch from './dispatch'
import dispatchSessionError from './dispatchSessionError';

export const actions = {
    dispatch,
    dispatchSessionError,
};

export default actions;
